import { forwardRef } from 'react'
import { InputProps } from '../../routes/shared/_types'

export const NumberInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name,
      label = '',
      placeholder,
      errorMessage,
      helpText,
      maxLength,
      ...props
    },
    ref
  ) => {
    return (
      <div className="w-full">
        {label && (
          <span
            className={`mb-2 block text-base font-normal ${
              errorMessage ? 'text-alert' : 'text-content-black'
            }`}
          >
            {label}
          </span>
        )}
        <div className="relative">
          <input
            className={`h-[42px] w-full rounded border ${
              errorMessage ? 'border-alert' : 'border-input'
            } px-3 py-1.5 text-16 disabled:bg-bg-lighter disabled:border-border-normal disabled:cursor-not-allowed`}
            placeholder={placeholder}
            type="text"
            ref={ref}
            name={name}
            maxLength={maxLength}
            onChange={(e) => {
              if (props.onChange) {
                props.onChange(e.target.value.replace(/[^0-9-]/g, ''))
              }
            }}
            disabled={props.disabled}
            onBlur={props.onBlur}
            value={props.value}
          />
          {props.disabled && (
            <div className={`absolute top-1/4 right-[12px]`}>
              <i className="fa-solid fa-lock" style={{ color: '#D5D9DD' }}></i>
            </div>
          )}
        </div>
        {errorMessage && (
          <p className="mb-1 text-xs text-alert">
            {typeof errorMessage === 'string'
              ? errorMessage
              : errorMessage.message}
          </p>
        )}
        {helpText && (
          <div className="text-xs text-content-light">{helpText}</div>
        )}
      </div>
    )
  }
)

export default NumberInput
